import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useApi } from "../api/useApi";
import { ensureAccount } from "../api/resources";

// Emails already registered this page load (StrictMode runs effects twice; one call is enough).
const done = new Set<string>();

/**
 * Makes sure the signed-in Auth0 identity has an account on the API, once per page load, as the
 * dashboard opens. Without it a brand-new sign-in (the first tester, Apple; a second Google
 * account) could browse but not upload: the API has no user row for the email, and
 * /platform/uploadNew answers with no ids. Renders nothing; a failure is logged, not shown —
 * the next page load tries again.
 */
export default function AccountEnsurer() {
  const { user } = useAuth0();
  const apiFetch = useApi();
  const email = user?.email;
  useEffect(() => {
    if (!email || done.has(email)) return;
    done.add(email);
    ensureAccount(apiFetch, user!).catch((e) => {
      done.delete(email);
      // eslint-disable-next-line no-console
      console.warn("[account] getOrCreate failed:", e);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email]);
  return null;
}

/** Tests only. */
export function resetAccountEnsurerForTests() {
  done.clear();
}
